// Import the functions you need from the SDKs you need

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, query, getDocs, collection, where, addDoc } from "firebase/firestore";
//import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use

// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyChIj9ck8QyAN07a6Y5dAhcstXhbN9zHFk",
  authDomain: "h4g-minimart.firebaseapp.com",
  databaseURL: "https://h4g-minimart-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "h4g-minimart",
  storageBucket: "h4g-minimart.firebasestorage.app",
  messagingSenderId: "635936721379",
  appId: "1:635936721379:web:86bf2fceb7a51b180a38d6",
  measurementId: "G-XDP0RSGR0P"
};


// Initialize Firebase

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export const db = getFirestore(app);

export default auth;
